import ResetIcon from "./ResetIcon.png";
import ExpandIcon from "./ExpandIcon.png";
import DownloadIcon from "./DownloadIcon.png";
import FallbackResetIcon from "./FallbackResetIcon.png";
import FallbackExpandIcon from "./FallbackExpandIcon.png";
import FallbackDownloadIcon from "./FallbackDownloadIcon.png";
import Wallpaper from "./Wallpaper.jpg";

export {
	ResetIcon,
	ExpandIcon,
	DownloadIcon,
	FallbackResetIcon,
	FallbackExpandIcon,
	FallbackDownloadIcon,
};

export const imageSources = [
	ResetIcon,
	ExpandIcon,
	DownloadIcon,
	FallbackResetIcon,
	FallbackExpandIcon,
	FallbackDownloadIcon,
	Wallpaper,
];
